// @ts-check
import api from '../utils/apiClient';
import { assertShape } from '../utils/apiGuards';

/** @param {{from?: string, to?: string}} range */
const query = ({ from, to }, extra = {}) => {
  const params = new URLSearchParams();
  if (from) params.append('from', from);
  if (to) params.append('to', to);
  Object.entries(extra).forEach(([key, value]) => params.append(key, String(value)));
  return params.toString();
};

const adminInvoiceService = {
  /**
   * @param {{from?: string, to?: string}} range
   * @param {number} [page]
   * @param {number} [limit]
   */
  async list(range, page = 1, limit = 50) {
    const data = await api.get(`/api/admin/invoices?${query(range, { page, limit })}`);
    assertShape(data, ['invoices', 'count', 'totals'], 'adminInvoiceService.list');
    return data;
  },

  /**
   * ZIP of every invoice PDF in the range plus a summary.csv, for the CA.
   * @param {{from: string, to: string}} range
   * @returns {Promise<Blob>}
   */
  async exportZip(range) {
    return api.download(`/api/admin/invoices/export?${query(range)}`);
  },
};

export default adminInvoiceService;
